/* eslint-disable no-unused-vars */
import React from 'react';
import { Select, Flex } from '@chakra-ui/react';
import { emitCustomEvent } from 'react-custom-events';
import { HiOutlineGlobeAlt } from 'react-icons/hi';
import { deleteLocalStorage, LocalStorageKeys, setLocalStorage } from '../../../utils/localStorageHelper';
import { useHistory } from 'react-router-dom';
import useChangeLanguage from '../../../hooks/useChangeLanguage';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

export default function LanguageSelect({ isHeroSection }: any) {
  const { t } = useTranslation();
  const { currentLang, languages, changeLanguage } = useChangeLanguage();
  const queryClient = useQueryClient();
  const updateLanguage = (e: any) => {
    e.preventDefault();
    emitCustomEvent('language');
    const locale = e.target.value;
    deleteLocalStorage(LocalStorageKeys.PropertyInfoContext);
    changeLanguage(locale);
    queryClient.invalidateQueries('api/v1/properties/search');
  };

  return (
    <Flex alignItems="center" mr="1em">
      <Select
        size="xs"
        value={currentLang}
        onChange={updateLanguage}
        display={{
          base: 'block',
          md: 'block',
        }}
        border="0"
        color="gray.600"
        bg={!isHeroSection ? 'inherit' : 'white'}
        borderRadius={10}
        _hover={{
          cursor: 'pointer',
        }}
        icon={<HiOutlineGlobeAlt />}
      >
        {languages.map((language) => (
          <option key={language} value={language}>
            {t(`languages.${language}`)}
          </option>
        ))}
      </Select>
    </Flex>
  );
}
